import React from 'react';
import VideoPlayer from '../components/VideoPlayer';
import { motion } from 'framer-motion';

const LiveTV = ({ currentTime }) => {
  return (
    <div className="min-h-screen px-4 sm:px-6 lg:px-8 py-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8"
        >
          <h1 className="text-3xl lg:text-4xl font-bold text-white mb-4">Live Television</h1>
          <p className="text-gray-300 text-lg">
            Watch Ligon Road Innovations LLC Television live - broadcasting 24/7 with cutting-edge content
          </p>
        </motion.div>
        
        <div className="w-full">
          <VideoPlayer />
        </div>
      </div>
    </div>
  );
};

export default LiveTV;